/* B53 (25/09/2026) : un fichier Excel francais separe ses colonnes par un
   point-virgule ; la lecture imposait la virgule, et tout le fichier etait
   refuse (« emails inutilisables »). On laisse Papa Parse deviner le separateur
   parmi ceux qu'on rencontre vraiment : virgule, point-virgule, tabulation. */
export const OPTIONS_LECTURE_CSV = {
  skipEmptyLines: "greedy",
  header: true,
  delimiter: "",
  delimitersToGuess: [",", ";", "\t"],
}

/* Un fichier d'une seule colonne (le format conseille) n'a aucun separateur a
   deviner : Papa Parse le signale par une erreur « UndetectableDelimiter » et
   retombe sur la virgule, ce qui est juste. Ce n'est pas une erreur de lecture. */
export const vraiesErreurs = (erreurs) => (erreurs || []).filter((e) => e?.code !== "UndetectableDelimiter")
